<div class="numero_piezas">{{ numeroSolicitudes }}</div>
<div class="descripcion pendiente-de-validación">DISEÑOS ANALÓGICOS PENDIENTES DE VALIDAR</div>
